import styled from 'styled-components';

import { Skeleton } from '@crm-framework/skeleton';
import { colors } from '@crm-framework/theme';

export const Wrapper = styled.article`
  max-width: 400px;
  width: max-content;
  cursor: initial;
  color: ${colors.DEFAULT_FONT_COLOR};

  & span {
    color: inherit;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
`;

export const UserFullName = styled.h4`
  margin: 0 0 5px 5px;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const ValueOfKey = styled.span<{ isCanCopy: boolean }>`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  ${({ isCanCopy }) => !isCanCopy && 'user-select: none'}
`;

export const SkeletonWrapper = styled(Wrapper)`
  min-width: 200px;
`;

export const SkeletonHeader = styled(Skeleton)`
  margin-bottom: 5px;
`;
